import React from "react";

import Icon from "../../../../components/icon";

import * as S from "../styles";

import { planData } from "../utils/plan-data";

import IProps from "./props";

const PlanComparison: React.FC<IProps> = ({ packageList, handleSubmit }) => {
  const renderCell = (feature: any): React.ReactNode => {
    if (feature.included !== undefined) {
      return (
        <Icon name={feature.included ? "checkbox-circle" : "close-circle"} />
      );
    }
    if (feature.value) {
      return feature.value;
    }
    return null;
  };

  console.log("PACKAGE_LIST: ", packageList);
  return (
    <S.Grid>
      <div className="row header">
        <div className="row-title" />
        {planData.map((plan, index) => (
          <div key={index} className={`plan ${index === 2 ? "middle" : ""}`}>
            <div className="plan-title">{plan.name}</div>
            <div className="plan-value">{plan.price}</div>
          </div>
        ))}
      </div>

      {planData[0].features.map((feature, featureIndex) => (
        <div key={featureIndex} className="row">
          <div className="row-title">{feature.name}</div>
          {planData.map((plan, planIndex) => (
            <div key={planIndex} className={planIndex === 2 ? "middle" : ""}>
              {renderCell(plan.features[featureIndex])}
            </div>
          ))}
        </div>
      ))}

      <div className="row">
        <div className="row-title" />
        {planData.map((plan, index) => (
          <div key={index} className={index === 2 ? "middle button" : ""}>
            <S.Button onClick={() => handleSubmit(packageList.find((item) => item.packageEnum === planData[index].packageEnum))}>
              Quero este!
            </S.Button>
          </div>
        ))}
      </div>
    </S.Grid>
  );
};

export default PlanComparison;
